import { FLAG_RC_ANALYTICS_IFRAME } from '@app/feature-flags/flags';
import { selectOrganizationStatus } from '@app/routes/organization/selectors';
import { selectFlags, selectOrganizationId } from '@app/store/selectors';
import { useAppSelector } from '@app/store/store';
import { GraphqlProvider } from '@hopin-team/dashboard-shared-react';
import { useTranslation } from '@hopin-team/provider-translation';
import { Loading as LoadingUI } from '@hopin-team/ui-loading';
import React from 'react';

import { RouteNotFound } from '../../components/route-not-found/route-not-found';
import { TabContent } from '../analytics/features/top-bar/tab-content';
import { TopBar } from '../analytics/features/top-bar/top-bar';
import { AnalyticsProvider } from '../analytics/providers/analytics-provider';
import { AuthenticationProvider } from '../analytics/providers/authentication-provider';
import { getHost } from '../analytics/services/endpoints';

const Loading = () => {
  const { t } = useTranslation();
  return <LoadingUI text={t('loading')} poweredByText={t('poweredBy')} />;
};

const IframeAnalyticsPage = () => {
  const organizationDataStatus = useAppSelector(selectOrganizationStatus);

  if (organizationDataStatus !== 'success') {
    return <Loading />;
  }

  return (
    <div className="pb-10">
      <TopBar layout="embedded" />
      <TabContent />
    </div>
  );
};

export const AnalyticsIframe = () => {
  const orgId = useAppSelector(selectOrganizationId) || '';
  const host = getHost();
  const flags = useAppSelector(selectFlags);
  const isEnabled = flags?.[FLAG_RC_ANALYTICS_IFRAME];

  if (!flags) {
    return <Loading />;
  }

  if (!isEnabled) {
    return <RouteNotFound />;
  }

  return (
    <GraphqlProvider fallback={<Loading />}>
      <AuthenticationProvider host={host} organisationId={orgId}>
        <AnalyticsProvider initialTab="admin" persistFilters={false}>
          <div className="relative">
            <div className="px-6">
              <IframeAnalyticsPage />
            </div>
          </div>
        </AnalyticsProvider>
      </AuthenticationProvider>
    </GraphqlProvider>
  );
};
